import { render, staticRenderFns } from "./alerts_shell.vue?vue&type=template&id=134edf30&scoped=true&"
import script from "./alerts_shell.vue?vue&type=script&lang=js&"
export * from "./alerts_shell.vue?vue&type=script&lang=js&"
import style0 from "./alerts_shell.vue?vue&type=style&index=0&id=134edf30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134edf30",
  null
  
)

export default component.exports